<template>
  <b-container fluid>
    <b-row class="my-5" align-h="center">
			<b-col cols="10">
				<b-container fluid>
					<b-row>
						<b-col class="player-container" sm="12" lg="8">
							<div>
								<!-- TODO: improve responsiveness to resize the player as player-height does not allow dynamic values. -->
								<vimeo-player :video-id="videoURL" :options="options"></vimeo-player>
							</div>
						</b-col>
						<b-col sm="12" lg="4" class="consent-card" :style="cssVars">
							<p class="title">{{ consentCard.title }}</p>
							<p class="text">{{ consentCard.text }}</p>
							<b-button v-for="link in consentCard.buttons" :key="link.title" :href="link.url" :target="link.target">
								{{ link.title }}
							</b-button>
						</b-col>
					</b-row>
				</b-container>
			</b-col>
    </b-row>
  </b-container>
</template>

<script>
import { vueVimeoPlayer as vimeoPlayer } from 'vue-vimeo-player'

export default {
  components: { vimeoPlayer },
  props: {
    videoURL: String,
    videoType: String,
    textTrack: String,
		consentCard: Object
  },
	computed: {
		cssVars() {
      return {
				"--background-image-url": `url(/strapi/${this.consentCard.icon.data.attributes.url})`
			}
    }
	},
  data () {
    return {
      options: {
        texttrack: this.textTrack,
        responsive: true
      }
    }
  }
}
</script>

<style scoped src="@/assets/css/video-player-ribbon.css"/>
